import React, { Component } from 'react';
import * as Styles from './Styles';
import Item from './Item';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../../core/Store';
import * as FormManager from '../../../../reducers/ui/form';
import * as DictionariesRisksSelectors from '../../../../reducers/data/dictionaries/risks/selectors';

type State = {};

class ReceiptComponent extends Component<PropsFromRedux, State> {
	state = {};

	MULTIPLY_FACTOR = 1.5;

	calcTotalPrice = () => {
		const allSelectedRisks = this.props.allRisksDict.filter((el) =>
			this.props.allSelectedRisksIds.includes(el.riskId)
		);
		const mappedSelectedRisks = allSelectedRisks.map((el) => {
			if (el.riskId <= 6 && this.props.extendedOcCoverageSelected) {
				return {
					...el,
					riskContribution:
						el.riskContribution * this.MULTIPLY_FACTOR,
				};
			}
			return el;
		});

		if (mappedSelectedRisks.length === 0) {
			return '0.00';
		}

		if (mappedSelectedRisks.length === 1) {
			return mappedSelectedRisks[0].riskContribution;
		}

		return mappedSelectedRisks
			.map((el) => el.riskContribution)
			.reduce((prev, current) => (prev += current));
	};

	getRiskName = (riskId: number | undefined) => {
		if (!riskId) return '--';

		// OC
		if (riskId <= 6) return 'OC';
		// NNW całodobowe
		if (riskId >= 8 && riskId <= 11) return 'NNW całodobowe';
		// NNW ograniczone
		if (riskId >= 12 && riskId <= 15) return 'NNW ograniczone';
		// NNW Klauzule
		if (riskId >= 16 && riskId <= 20) {
			const RISKS_SHORTNAMES = [
				{ id: 16, name: 'Zwrot kosztów leczenia i rehabilitacji' },
				{ id: 17, name: 'Klauzula uciążliwego leczenia' },
				{ id: 18, name: 'Niezdolność do pracy' },
				{ id: 19, name: 'Klauzula naruszenia nietykalności cielesnej' },
				{ id: 20, name: 'Klauzula HIV/WZW' },
			];

			return (
				RISKS_SHORTNAMES.find((el) => el.id === riskId)?.name || '--'
			);
		}
		// KOP
		if (riskId >= 21 && riskId <= 22) return 'Koszty ochrony prawnej';

		return '--';
	};

	getRiskValue = (riskId: number | null) => {
		const risk = this.props.allRisksDict.find((el) => el.riskId === riskId);

		if (riskId === 17) {
			// 1% trwały uszczerbek na zdrowiu - 4 warianty
			const table = ['300 zł', '400 zł', '500 zł', '1 000 zł'];

			if (
				this.props.allSelectedRisksIds.includes(8) ||
				this.props.allSelectedRisksIds.includes(12)
			)
				return table[0];
			if (
				this.props.allSelectedRisksIds.includes(9) ||
				this.props.allSelectedRisksIds.includes(13)
			)
				return table[1];
			if (
				this.props.allSelectedRisksIds.includes(10) ||
				this.props.allSelectedRisksIds.includes(14)
			)
				return table[2];
			if (
				this.props.allSelectedRisksIds.includes(11) ||
				this.props.allSelectedRisksIds.includes(15)
			)
				return table[3];
		}

		if (riskId === 19) return '2 x 1 000 zł';

		return `${risk?.riskInsuranceAmount.toLocaleString()} zł` || '--';
	};

	render() {
		const selectedOCRiskId = this.props.allSelectedRisksIds.find(
			(id) => id <= 6
		);
		const selectedOCRisk = this.props.allRisksDict.find(
			(el) => el.riskId === selectedOCRiskId
		);

		const allSelected = Array.from(this.props.allSelectedRisksIds);
		const sorted = allSelected.sort((a, b) => a - b);

		return (
			<Styles.Wrapper>
				<Styles.TitleFont>Twoje Ubezpieczenie</Styles.TitleFont>
				<Styles.ItemsContainer>
					{sorted.map((selectedRiskId) => {
						const riskFull = this.props.allRisksDict.find(
							(el) => el.riskId === selectedRiskId
						);

						return (
							<React.Fragment key={selectedRiskId}>
								<Item
									price={riskFull?.riskContribution || 0}
									title={this.getRiskName(riskFull?.riskId)}
									value={this.getRiskValue(
										riskFull?.riskId || 0
									)}
								/>
								{this.props.extendedOcCoverageSelected &&
									selectedOCRisk &&
									selectedOCRiskId === selectedRiskId && (
										<Item
											price={
												selectedOCRisk.riskContribution /
												2
											}
											title="Rozszerzenie OC na cały świat"
											value=""
										/>
									)}
							</React.Fragment>
						);
					})}
				</Styles.ItemsContainer>
				<Styles.SummaryContainer>
					<p>składka roczna:</p>
					<p>{this.calcTotalPrice()} zł</p>
				</Styles.SummaryContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => {
		const kop = DictionariesRisksSelectors.getRisksKop(state);
		const oc = DictionariesRisksSelectors.getRisksOc(state);
		const nnw = DictionariesRisksSelectors.getRisksNnw(state);
		const nnwKlauzule =
			DictionariesRisksSelectors.getRisksNnwKlauzule(state);
		return {
			allSelectedRisksIds:
				FormManager.Selectors.getSelectedRisksIds(state),
			allRisksDict: [...kop, ...oc, ...nnw, ...nnwKlauzule],
			extendedOcCoverageSelected:
				FormManager.Selectors.getExtendedOcCoverageSelected(state),
		};
	},
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Receipt = connector(ReceiptComponent);
export default Receipt;
